const SplitterId = {
  AppLayout: 'APP_LAYOUT_SPLITTER',
  PageBasedLayout: 'PAGED_BASED_LAYOUT_SPLITTER'
};

export { SplitterId };
